import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../assets/img/ImageIndex";
import { contactUs } from "../Apis/index";

function ContactUs() {
  const [formData, setFormData] = useState({
    "Your email": "",
    "Your name": "",
    Phone: "",
    Website: "",
    "Zip Code": "",
    Message: ""
  });

  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [formError, setFormError] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    // Set document title and meta tags
    document.title = 'Apply for a Business Loan in the USA | Contact EnvoCapital';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ready to apply for a business loan? Contact EnvoCapital today to discuss working capital, fast approvals, and flexible funding options for your business.');
    }
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormError(false);
    setFieldErrors({ ...fieldErrors, [e.target.name]: "" });

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // VALIDATION FOR ALL FIELDS
  const validateForm = () => {
    let errors = {};

    // Email
    if (!formData["Your email"].trim()) {
      errors["Your email"] = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData["Your email"])) {
      errors["Your email"] = "Enter a valid email.";
    }

    // Name
    if (!formData["Your name"].trim()) {
      errors["Your name"] = "Name is required.";
    }

    // Phone
    if (!formData.Phone.trim()) {
      errors["Phone"] = "Phone number is required.";
    }

    // Website
    // if (!formData.Website.trim()) {
    //   errors["Website"] = "Website is required.";
    // }

    // Zip code
    if (!formData["Zip Code"].trim()) {
      errors["Zip Code"] = "Zip Code is required.";
    }

    // Message
    if (!formData.Message.trim()) {
      errors["Message"] = "Message is required.";
    }

    setFieldErrors(errors);
    setFormError(Object.keys(errors).length > 0);

    return Object.keys(errors).length === 0;
  };

  // Submit form using the API
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);

    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await contactUs(formData);

      if (response.status === 200) {
        setMsg("Your message has been sent successfully!");
        setFormData({
          "Your email": "",
          "Your name": "",
          Phone: "",
          Website: "",
          "Zip Code": "",
          Message: ""
        });
        setFieldErrors({});
        setFormError(false);
      } else {
        setMsg("Failed to send message. Please try again.");
        setFormError(true);
      }
    } catch (error) {
      console.error("Contact form error:", error);
      setMsg(error.response?.data?.message || "An error occurred. Please try again.");
      setFormError(true);
    }

    setLoading(false);
  };

  return (
    <div className="loan-program-page">
      <div className="page-banner-area bg-gray2">
        <div className="container mw-1380">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="page-banner-content">
                <ul className="ps-0 list-unstyled breadcrumbs">
                  <li><Link to="/">Home</Link></li>
                  <li>Contact Us</li>
                </ul>
                <h1>Connect With EnvoCapital: Your Path to Smarter Financing Starts Here</h1>
                <p>We’re here to support you every step of the way. Whether you have questions, need guidance, or want to explore the right funding options for your business, our team is ready to help. Reach out to us for a personalized, transparent, and seamless experience tailored to your financial needs.</p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="page-banner-img text-center text-lg-end">
                <img src={IMAGES.bannerImg7} className="img" alt="banner-img" />
              </div>
            </div>  
          </div>
        </div>
      </div>

      {/* FORM AREA */}
      <div className="container ptb-130">
        <div className="row">
          {/* MAP */}
          <div className="col-md-6 elementor-custom-embed">
            <iframe
              style={{ width: "100%", height: "100%" }}
              loading="lazy"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4294.890256117208!2d-80.1656681240235!3d25.8957622030515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9ad8a832f69dd%3A0xffbe6a6051847d85!2s12864%20Biscayne%20Blvd%20%231018%2C%20North%20Miami%2C%20FL%2033181%2C%20USA!5e1!3m2!1sen!2sin!4v1763616564996!5m2!1sen!2sin"
              title="Map"
            ></iframe>
          </div>

          <div className="col-md-6 contact-us-content">
            <h2 className="mb-0">Contact with us for any help</h2>

            {msg && (
              <div 
                className={`alert ${formError ? 'alert-danger' : 'alert-success'}`}
              >
                {msg}
              </div>
            )}

            <form
              onSubmit={handleSubmit}
              style={{
                border: formError ? "2px solid #dc3545" : "2px solid transparent",
                padding: formError ? "15px" : "15px 15px 0px",
                borderRadius: "8px"
              }}
            >
              {/* EMAIL */}
              <div className="mb-3">
                <label className="label">Your email</label>
                <input
                  type="email"
                  name="Your email"
                  className={`form-control ${fieldErrors["Your email"] ? "is-invalid" : ""}`}
                  value={formData["Your email"]}
                  onChange={handleChange}
                />
                {fieldErrors["Your email"] && (
                  <div className="invalid-feedback">{fieldErrors["Your email"]}</div>
                )}
              </div>

              {/* NAME */}
              <div className="mb-3">
                <label className="label">Your name</label>
                <input
                  type="text"
                  name="Your name"
                  className={`form-control ${fieldErrors["Your name"] ? "is-invalid" : ""}`}
                  value={formData["Your name"]}
                  onChange={handleChange}
                />
                {fieldErrors["Your name"] && (
                  <div className="invalid-feedback">{fieldErrors["Your name"]}</div>
                )}
              </div>

              {/* PHONE */}
              <div className="mb-3">
                <label className="label">Phone</label>
                <input
                  type="text"
                  name="Phone"
                  className={`form-control ${fieldErrors["Phone"] ? "is-invalid" : ""}`}
                  value={formData.Phone}
                  onChange={handleChange}
                />
                {fieldErrors["Phone"] && (
                  <div className="invalid-feedback">{fieldErrors["Phone"]}</div>
                )}
              </div>

              {/* WEBSITE */}
              <div className="mb-3">
                <label className="label">Website</label>
                <input
                  type="text"
                  name="Website"
                  className={`form-control ${fieldErrors["Website"] ? "is-invalid" : ""}`}
                  value={formData.Website}
                  onChange={handleChange}
                />
                {/* {fieldErrors["Website"] && (
                  <div className="invalid-feedback">{fieldErrors["Website"]}</div>
                )} */}
              </div>

              {/* ZIP CODE */}
              <div className="mb-3">
                <label className="label">Zip Code</label>
                <input
                  type="text"
                  name="Zip Code"
                  className={`form-control ${fieldErrors["Zip Code"] ? "is-invalid" : ""}`}
                  value={formData["Zip Code"]}
                  onChange={handleChange}
                />
                {fieldErrors["Zip Code"] && (
                  <div className="invalid-feedback">{fieldErrors["Zip Code"]}</div>
                )}
              </div>

              {/* MESSAGE */}
              <div className="mb-3">
                <label className="label">Message</label>
                <textarea
                  name="Message"
                  className={`form-control ${fieldErrors.Message ? "is-invalid" : ""}`}
                  rows="5"
                  value={formData.Message}
                  onChange={handleChange}
                ></textarea>
                {fieldErrors.Message && (
                  <div className="invalid-feedback">{fieldErrors.Message}</div>
                )}
              </div>

              {/* SUBMIT BUTTON */}
              <button
                type="submit"
                className="btn btn-dark w-100"
                disabled={loading}
              >
                {loading ? "Sending..." : "Submit Your Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;